/* eslint-disable */
<template>
  <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <h2 class="titleMobile">{{ $t('views.configuration.title') }}</h2>
      <div class="plantillaSuscrip">
        <v-row>
          <v-col cols="12">
            <p class="description"
            :style="{marginTop: '1rem'}">{{ $t('views.configuration.description') }} </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <StopMobileNotifications class="stop-notif"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
            <v-card class="btn-card"
            :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
            background: '#e6f1ee'}"
            to="/configuration/requests">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.configuration.requests.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                  >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.configuration.requests.description') }}</p>
            </div>
          </v-card>
          <v-card class="btn-card"
          :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
          background: '#e6f1ee'}"
          to="/configuration/applications">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.configuration.applications.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.configuration.applications.description') }}</p>
            </div>
          </v-card>
          <v-card class="btn-card"
            :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
            background: '#e6f1ee'}"
            to="/configuration/communication">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.configuration.communication.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                  >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.configuration.communication.description') }}</p>
            </div>
          </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapState, mapGetters } from 'vuex';
import { StopMobileNotifications } from '@/components';

export default {
  name: 'ConfigurationView',
  components: { StopMobileNotifications },
  data() {
    return {
      isBadge: false,
      isSubscription: true,
      loading: false,
      showFilters: false,
      loadingSubscriptions: true,
      errorSuscripciones: false,
      name: '',
      textInput: '',
      msgErrorSuscripciones: '',
      titleAllGroups: 'Todo',
      showMenuGroup: null,
      groupingsAppList: [],
      groupingsAppListAux: [],
      applicationsAppList: [],
      stringSubscriptions: 'Todo',
      showMenuOptions: [],
      dataLabel: false,
      isAppInstalled: true,
      filtersInitialMySubscription: [],
      filtersMySubscription: [],
      panelActivo: null,
    };
  },
  props: {
    applications: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    color() {
      // eslint-disable-next-line no-bitwise
      const hash = this.user.fullName
        .split('')
        .reduce((tot, curr) => curr.charCodeAt(0) + ((tot < 5) - tot), 0);
      return Array.from({ length: 3 }, (_, i) => i).reduce((acum, idx) => {
        // eslint-disable-next-line no-bitwise
        const val = (hash >> (idx * 8)) & 0xff;
        return acum + `00${val.toString(16)}`.substr(-2);
      }, '#');
    },
  },
  methods: {
    isCitizen() {
      return this.user.hasIosUser();
    },
  },
  created() {
    if (this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes acceso para visualizar este módulo',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });
      this.$router.push('/');
    } else {
      if (this.applications && this.applications.length > 0) { // eslint-disable-line
        this.panelActivo = 0;
      }
    }
  },

};
</script>
<style lang="scss" scoped>
$header-padding: 10 0;
.v-application--is-ltr .v-expansion-panel-header {
  width: fit-content !important;
  text-align: left !important;
}

.v-expansion-panel-header > *:not(.v-expansion-panel-header__icon)  {
  order: 2;
}
.v-menu__content{
    margin-top:2.5rem;
    box-shadow: none !important;
}
.listSheet{
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
     0px 8px 10px 1px rgba(0, 0, 0, 0.14),
     0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
    display: grid;
    border: 1px green solid;
    border-radius: 0.4rem;
    padding: 0px !important;
}
.listSheetItem{
    display: block;
    min-height: 1rem;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.loadingProgress{
    height: 10rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
}
.notification--title {
    font-size: 1rem;
  }
  .textEllipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .selectCol {
    padding: 0;
  }
  .plantillaTree {
    background-color: white;
  }

  .plantillaSuscrip {
    background-color: white;
    padding-bottom: 1rem;
    margin-bottom: 1em;
    margin-top: 1em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
  }

  .misSuscripciones {
    color: #27846d !important;
    caret-color: #27846d !important;
    background-color: #e1f2ee !important;
  }

  .sinEstilosMisSuscripciones {
    color: #000000 !important;
    background-color: #e0e0e0 !important;
  }

  .card {
    flex: 0 0 33.3333%;
  }
  .plantillaChips {
    background: transparent;
  }

  .container-apps {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .v-item-group .v-slide-group__wrapper .v-slide-group__content {
    display: flex!important;
    flex-wrap: wrap!important;
    width: 100%!important;
  }
  .container_form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 1rem;
  }

  .btn__suscripciones {
    margin-left: 2rem;
  }

  .chip__filter {
    padding: 0;
    padding-left: 15px;
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
  }

  .card__aplicacion {
    width: 100%;
  }
  .v-card__title{
    white-space: initial!important;
    word-break: inherit;
  }
  .msgErrorSuscripciones {
    margin-left: 1.5rem;
  }
  .chip__active {
    color: #27846d !important;
    background-color: #e6f1ee;
    border: 1px solid #27846d !important;
  }
  .description {
    padding: 0;
    margin: 0 2rem;
  }
  .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  .cardTitle {
    // align-items: center;
    // display: flex;
    // flex-wrap: wrap;
    font-size: 1rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
    line-height: initial !important;
    //word-break: none !important;
  }
  .iconChips{
  color:#27846d !important;
  }

  .v-expansion-panel-header {
    display: flex !important;
    justify-content: space-between !important;
  }
  .v-expansion-panel-header__icon {
      margin-left: 0 !important;
  }

  .btn-card:hover {
    border: 1px solid #27846d;
  }

  @media (max-width: 900px) {
    .stop-notif {
      margin-left: 2rem;
    }

    .facet_sidebar {
      display: none;
    }
    .card.v-card {
      flex: initial;
      flex-direction: column;
    }
    .v-card__title {
      padding: 1rem 1rem 0!important;
      font-size: .8rem !important;
    }
    .v-card__actions {
      height: 50px!important;
      padding: 1rem 1rem!important;
    }
    .chip__test > .v-slide-group__wrapper{
      background-color: red !important;
    }
    .cardTitle {
    // align-items: center;
    // display: flex;
    // flex-wrap: wrap;
    font-size: .8rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
    line-height: initial !important;
    //word-break: none !important;
  }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 600px) {
    .btn__suscripciones {
      margin-left: 0;
    }
    div.v-slide-group__content {
      flex-wrap: wrap !important;
      width: 100% !important;
      background-color: red;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 768px) {
    .titleMobile{
      margin-left: 2rem !important;
    }
  }

</style>
